import {
	AddOrdersText,
	EnterTruckInformationText,
	ReplacementReason,
	ReplacementReviewStepperText,
	ReplacementsFlyoutSelectPartText,
	ReviewTrucksText
} from "constants/text";
import {
	NewOrderBuildOrderLabel,
	NewOrderShippingDetailsLabel,
	NewOrderViewPriceEstimateTitle,
	ProQuoteReviewPageTitle,
	ReviewAndPlaceOrder
} from "../../NewOrders/constants";
import { Params } from "react-router";

interface Step {
	title: string;
	pathname: string;
}

export const stepperFlows = (params: Readonly<Params<string>>): Step[][] => [
	// New Orders
	[
		{
			title: NewOrderBuildOrderLabel,
			pathname: "/new-order/build-order"
		},
		{
			title: NewOrderViewPriceEstimateTitle,
			pathname: "/new-order/view-price-estimates"
		},
		{
			title: NewOrderShippingDetailsLabel,
			pathname: "/new-order/shipping-details"
		},
		{
			title: ReviewAndPlaceOrder,
			pathname: "/new-order/review-order"
		}
	],
	// Add-Ons
	[
		{
			title: NewOrderBuildOrderLabel,
			pathname: "/add-ons/build-order"
		},
		{
			title: NewOrderViewPriceEstimateTitle,
			pathname: "/add-ons/view-price-estimates"
		},
		{
			title: NewOrderShippingDetailsLabel,
			pathname: "/add-ons/shipping-details"
		},
		{
			title: ReviewAndPlaceOrder,
			pathname: "/add-ons/review-order"
		}
	],
	// Custom Colors
	[
		{
			title: NewOrderBuildOrderLabel,
			pathname: "/custom-color/build-order"
		},
		{
			title: NewOrderViewPriceEstimateTitle,
			pathname: "/custom-color/view-price-estimates"
		},
		{
			title: NewOrderShippingDetailsLabel,
			pathname: "/custom-color/shipping-details"
		},
		{
			title: ReviewAndPlaceOrder,
			pathname: "/custom-color/review-order"
		}
	],
	// Replacements
	[
		{
			title: ReplacementsFlyoutSelectPartText,
			pathname: `/replacements/${params.orderId}`
		},
		{
			title: ReplacementReason,
			pathname: `/replacements/reason/${params.orderId}`
		},
		{
			title: NewOrderShippingDetailsLabel,
			pathname: `/replacements/shipping-details/${params.orderId}`
		},
		{
			title: ReplacementReviewStepperText,
			pathname: `/replacements/review/${params.orderId}`
		}
	],
	// Trucks
	[
		{
			title: EnterTruckInformationText,
			pathname: "/trucks/create-truck"
		},
		{
			title: AddOrdersText,
			pathname: "/trucks/add-order"
		},
		{
			title: ReviewTrucksText,
			pathname: "/trucks/review"
		}
	],
	// pro quote
	[
		{
			title: NewOrderBuildOrderLabel,
			pathname: "/new-quote/build-order"
		},
		{
			title: NewOrderViewPriceEstimateTitle,
			pathname: "/new-quote/view-price-estimates"
		},
		{
			title: ProQuoteReviewPageTitle,
			pathname: "/new-quote/review-order"
		}
	],
	// Marketing Materials/Merchandise
	[
		{
			title: "View Cart",
			pathname: "/marketing-materials/view-cart"
		},
		{
			title: "Enter Shipping",
			pathname: "/marketing-materials/shipping-details"
		},
		{
			title: "Review and Place Order",
			pathname: "/marketing-materials/review-cart"
		}
	]
];
